// extracted by mini-css-extract-plugin
module.exports = {"Container":"Modal_Container__pCW_c","BackDrop":"Modal_BackDrop__AJZqV"};